import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Fade, Dialog } from '@material-ui/core';
import { colors } from '../../../constants/styleConstants';
import Button from '../../../components/Button';
import { TP } from '../../../constants/consts';
import TimePicker from '../../../components/Fields/TimePicker';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 240,
    padding: 28,
    maxHeight: '95vh',
    borderRadius: 4,
    backgroundColor: colors.white,
    textAlign: 'center',
    '&:focus': {
      outline: 'none',
    },
  },
  button: {
    marginTop: '2rem',
  },
  error: {
    position: 'absolute',
    bottom: '-17px',
  },
}));

const TimeAddModal = ({ t, isOpened, onClose, submitFunc }) => {
  const classes = useStyles();
  const [time, setTime] = React.useState('');

  const enterClick = e => {
    if (e?.code === 'Enter') {
      // as call a func do not take updated state
      document.getElementById('time_submit').click();
    }
  };

  React.useEffect(() => {
    document.addEventListener('keyup', enterClick);
    return () => {
      document.removeEventListener('keyup', enterClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitTimeModal = () => {
    if (time && time.length !== 5) return;
    if (time) {
      submitFunc(time);
    } else {
      onClose();
    }
  };

  return (
    <Dialog
      open={isOpened}
      classes={{ root: classes.root }}
      onClose={() => {
        setTime('');
        onClose();
      }}
    >
      <Fade in={isOpened}>
        <div className={classes.paper}>
          <TimePicker
            id="performance-time-picker"
            onTimeChange={setTime}
            label={t(`${TP}.FN_TIME`)}
            field={{
              value: time,
              name: 'time',
            }}
            form={{
              errors: { time: time.length && time.length !== 5 ? `${TP}.FN_INVALID_TIME` : '' },
              touched: { time: true },
            }}
            errorMessageClass={classes.error}
            autoFocus
          />
          <Button onClick={submitTimeModal} id="time_submit" className={classes.button}>
            {t(`${TP}.m_SAVE`)}
          </Button>
        </div>
      </Fade>
    </Dialog>
  );
};

TimeAddModal.propTypes = {
  isOpened: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  submitFunc: PropTypes.func.isRequired,
};

TimeAddModal.defaultProps = {
  isOpened: false,
};

export default memo(TimeAddModal);
